let _nativeAppVersion: string | null = null;

export function setNativeAppVersion(version: string) {
  if (!version || !version.trim()) {
    return;
  }
  _nativeAppVersion = version;
}

/** Returns the native app version, or null if the native shell never completed initialization. */
export function getNativeAppVersion(): string | null {
  return _nativeAppVersion;
}
